import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/sections/Nav";
import Footer from "@/components/sections/Footer";
import BookingModal from "@/components/BookingModal";

export default function Layout() {
  useLenis();
  const { pathname } = useLocation();

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="grain relative bg-canvas text-ink">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BookingModal />
      <Toaster position="bottom-right" />
    </div>
  );
}
